"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _options = require("@module/options");

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _reduxForm = require("redux-form");

var _Component = _interopRequireDefault(require("./Component"));

var mapStateToProps = function mapStateToProps(state) {
  return {
    initialValues: state[_options.name]['user'],
    isValidForm: (0, _reduxForm.isValid)('options-email-change')(state),
    isPristineForm: (0, _reduxForm.isPristine)('options-email-change')(state)
  };
};

var mapActionsToProps = function mapActionsToProps(dispatch) {
  return {
    submitForm: (0, _redux.bindActionCreators)(_reduxForm.submit, dispatch)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapActionsToProps)(_Component["default"]);

exports["default"] = _default;